import { useEffect, useState } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { useAppInfoStore } from '../../store';

export const useGetAppTypeByApp = () => {
  const { setAppType, setFirebaseToken } = useAppInfoStore(
    useShallow((state) => ({
      setAppType: state.actions.setAppType,
      setFirebaseToken: state.actions.setFirebaseToken,
    }))
  );

  const [appVersion, setAppVersion] = useState<string | null>(null);

  const getAppTypeByApp = (): void => {
    try {
      if (window.JSBridge) {
        window.JSBridge.getAppType();
      }

      if (window.webkit) {
        window.webkit.messageHandlers.getAppType?.postMessage(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAppTypeResult = async (
    appType?: string | null,
    appVersion?: string | null,
    _hasDeepLink?: string | boolean,
    token?: string | null
  ): Promise<void> => {
    setAppType(appType ?? null);
    setAppVersion(appVersion ?? null);
    setFirebaseToken(token ?? null);
  };

  useEffect(() => {
    window.onAppTypeResult = handleAppTypeResult;
    getAppTypeByApp();

    return () => {
      window.onAppTypeResult = null;
    };
  }, []);

  return { appVersion };
};
